<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
      v-col.py-0.text-right
        v-btn(color="white", @click="save()", :disabled="loading") Save
    v-row(v-if="!loading")
      v-col.py-0
        app-entity-form(
          v-model="instance",
          :errors="errors",
          :entity="entity",
          showUser,
          :options="{ tabs: true, }",
        )
</template>

<script>
import axios from 'axios'

export default {
  name: 'entity-add',
  data: () => ({
    loading: true,
    instance: {
    },
    errors: {},
  }),
  computed: {
    entityName () {
      return 'Permission'
    },
    entity () {
      return this.$findEntity('Permission')
    },
    uid () {
      return this.$route.params.item
    },
  },
  methods: {
    log(val) {
      console.log(this.$cleanString(val));
    },

    /* TODO: docs */
    async save () {
      // return console.debug('INSTANCE', this.instance)
      // this.loading = true
      try {
        this.instance = (await axios.post('entity/graph', this.instance)).data
        this.$router.push({
          name: 'entities.index',
          params: { entity: this.entity.name }
        })
      } catch (error) {
        this.errors = error.response.data.errors
      }
      // this.loading = false
    },

    /* TODO: docs */
    async load () {
      if (this.uid) {
        try {
          const endpoint = this.$fetchLoad(`${this.entity.name}/${this.uid}`, true, 'ExtraData')
          this.instance = (await axios.get(endpoint, {
            _Entity: this.entity.name,
            uid: this.uid
          })).data;
        } catch (error) {
          console.error(error)
        }
      }
      this.loading = false
    }
  },
  async mounted () {
    await this.load()
  },
}
</script>
